import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  // AboutAds,
  PrivacyPolicy,
  TermsAndConditions,
} from "screens";
import AMMainPage from "./modules/am-bmp/AMMainPage/AMMainPage";

export const paths = {
  id: "/:id",
  signup: "/signup",
  login: "/login",
  auth: "/auth",
  confirmRegistration: "/confirm-registration/:token",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password/:key",
  aboutAds: "/about-ads",
  privacyPolicy: "/privacy-policy",
  termsService: "/terms-of-service",
  termsServiceSSP: "/terms-of-service-ssp",
  ngBmp: "/ng-bmp",
};

const routerConfig = [
    {
      key: '1',
      path: '*',
      component: <AMMainPage />,
    },
    // {
    //   key: '1',
    //   path: paths.aboutAds + paths.id,
    //   component: AboutAds,
    // },
    // {
    //   key: '2',
    //   path: paths.aboutAds,
    //   component: AboutAds,
    // },
    {
      key: '3',
      path: paths.privacyPolicy,
      component: <PrivacyPolicy />,
    },
    {
      key: '4',
      path: paths.termsService,
      component: <TermsAndConditions />,
    },
    // {
    //   key: '5',
    //   path: '*',
    //   component: redirectToNotfound,
    // },
  ];


export const LandingRoutes = () => {
  return (
    <Routes>
      { routerConfig.map((item: any) => (
        <Route key={item.key} path={item.path} element={item.component} />
      ))}
    </Routes>
  );
};
